import {
  FormControl,
  FormControlLabel,
  FormLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import { useEffect } from "react";

export const MdlFiltrosScreen = ({ onCargarRecuperacion, recarga }) => {
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState({
    fechainicio: "",
    fechafinal: "",
    lineacredito: "RV",
    mostrarcartera: "PV",
  });
  const onOpenModal = () => {
    var container = document.getElementById("mdlFiltros-modal");
    if (container === undefined || container === null) return;
    if (openModal === true) {
      container.style.display = "flex";
      // container.style.width = "460px";
      // container.style.height = "220px";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      // container.style.width = "0px";
      // container.style.height = "0px";
      setOpenModal(true);
    }
  };
  const onCargar = () => {
    if (
      state.fechainicio === undefined ||
      state.fechainicio === null ||
      state.fechainicio === ""
    ) {
      Swal.fire(
        "RECUPERACION DE CARTERA",
        "Favor de indicar la fecha de inicio",
        "warning"
      );
      return;
    }
    if (
      state.fechafinal === undefined ||
      state.fechafinal === null ||
      state.fechafinal === ""
    ) {
      Swal.fire(
        "RECUPERACION DE CARTERA",
        "Favor de indicar la fecha de final",
        "warning"
      );
      return;
    }
    onCargarRecuperacion(state)
      .then(() => onOpenModal())
      .catch((error) => {
        Swal.fire("RECUPERACION DE CARTERA", JSON.stringify(error), "error");
      });
  };
  useEffect(() => {
    if (recarga === true) {
      var container = document.getElementById("mdlFiltros-modal");
      if (container === undefined || container === null) return;

      container.style.display = "none";
      setOpenModal(true);
    }
  }, [recarga]);
  return (
    <div className="mdlFiltros">
      <div
        className="recuperacion-cartera-header-filtrado"
        onClick={() => onOpenModal()}
      >
        <FilterAltIcon /> Filtrar
      </div>
      <div className="mdlFiltros-modal" id="mdlFiltros-modal">
        <div className="mdlFiltros-modal-header">
          FILTRADO RECUPERACION DE CARTERA
        </div>
        <div className="mdlFiltros-modal-fechas">
          <TextField
            size="small"
            type="date"
            label="Fecha de Inicio"
            format={"DD/MM/YYYY"}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
            }}
            value={state.fechainicio}
            onChange={({ target }) =>
              setState({ ...state, fechainicio: target.value })
            }
          />
          <TextField
            size="small"
            type="date"
            label="Fecha Final"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
            }}
            value={state.fechafinal}
            onChange={({ target }) =>
              setState({ ...state, fechafinal: target.value })
            }
          />
        </div>
        <FormControl className="mdlFiltros-modal-lineacredito" size="small">
          <FormLabel
            size="small"
            id="demo-radio-buttons-group-label"
          >
            Línea de Crédito
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="RV"
            name="radio-buttons-group"
            onChange={(e) =>
              setState({ ...state, lineacredito: e.target.value })
            }
          >
            <FormControlLabel
              size="small"
              value="RV"
              control={<Radio size="small" />}
              label="Revolvente"
            />
            <FormControlLabel
              size="small"
              value="OP"
              control={<Radio size="small" />}
              label="Operación"
              defaultChecked={true}
            />
            {/* <FormControlLabel
              size="small"
              value="CO"
              control={<Radio size="small" />}
              label="CONSOLIDADO"
            /> */}
          </RadioGroup>
        </FormControl>
        <FormControl className="mdlFiltros-modal-tipocartera" size="small">
          <FormLabel
            size="small"
            id="demo-radio-buttons-group-label"
          >
            Mostrar Cartera
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="PV"
            onChange={(e) =>
              setState({ ...state, mostrarcartera: e.target.value })
            }
            name="radio-buttons-group"
          >
            <FormControlLabel
              size="small"
              value="PV"
              control={<Radio size="small" />}
              label="Por vencer"
            />
            <FormControlLabel
              size="small"
              value="VN"
              control={<Radio size="small" />}
              label="Vencida"
            />
          </RadioGroup>
        </FormControl>
        <div className="mdlFiltros-modal-acciones">
          <div
            className="mdlFiltros-modal-acciones-cancelar"
            onClick={() => onOpenModal()}
          >
            Cancelar
          </div>
          <div
            className="mdlFiltros-modal-acciones-guardar"
            onClick={() => onCargar()}
          >
            Cargar
          </div>
        </div>
      </div>
    </div>
  );
};
